module.exports = __webpack_public_path__ + "img/badge.35cc4522.svg";